import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import "./vendorDashboard.css";
import axiosInstance from "../../API/axiosInstance";
import { BsGridFill, BsPlusCircleFill, BsChatDotsFill, BsBarChartLineFill } from "react-icons/bs";
import useAuthCheck from "../../Auth/useAuthCheck";
import DynamicBreadcrumbs from '../dynamic_breadcumb/dynamic_breadcrumb';
import SiteFooter from '../../ui_components/site_footer/site_footer';
import DownloadAppUI from '../../ui_components/download_app/download_app';


export default function VendorDashboard() {
  const [vendorServices, setServices] = useState([]);
  const [currentUser, setCurrentUser] = useState();
  useAuthCheck();
  useEffect(() => {
    setCurrentUser(JSON.parse(localStorage.getItem("currentUser")));
    console.log(JSON.stringify(currentUser));
  }, [])

  useEffect(() => {
    const fetchServices = async () => {
      if (currentUser && currentUser.id) {
        const token = localStorage.getItem("token");
        try {
          const response = await axiosInstance.get(
            `/service/${currentUser.id}/all`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setServices(response.data)
          console.log("Response:", JSON.stringify(vendorServices));
        } catch (error) {
          console.error("Error fetching user details:", error);
        }
      }
    };

    fetchServices();
  }, [currentUser]); // Runs whenever currentUser changes


  return (
    <div id="main-dashboard-div" className="d-flex">
      <Dashboard currentUser={currentUser} />
    </div>
  )
}

function Dashboard({ currentUser }) {
  if (!currentUser) {
    return <div>Loading...</div>; // or a spinner
  }
  return (
    <div className='container'>
      <DynamicBreadcrumbs />
      <div className="dashboard-container">
        {/* User Welcome */}
        <div className="user-details mb-4">
          <h1 id="title">Welcome back, {currentUser.vendor_name}</h1>
          <h3 id="sub-title">
            You are logged in as <span>{currentUser.business_name}</span>
          </h3>
        </div>

        {/* Stats Section */}
        <div className="dashboard-stats">
          <div className="dashboard-card">
            <h5>Total Services</h5>
            <h2>{currentUser.noOfServices}</h2>
          </div>
          <div className="dashboard-card">
            <h5>Category</h5>
            <h2>{currentUser.business_category}</h2>
          </div>
          <div className="dashboard-card">
            <h5>City</h5>
            <h2>{currentUser.city}</h2>
          </div>
          <div className="dashboard-card">
            <h5>Plan</h5>
            <h2>{currentUser.planType}</h2>
          </div>
        </div>

        {/* --- Action Buttons Section with Links --- */}
        <div className="dashboard-actions">
          {/* Replace <button> with <Link> and add the 'to' prop */}
          <Link to={`/vendor/${currentUser.id}/services`} className="action-button">
            <BsGridFill />
            <span>Services</span>
          </Link>
          <Link to={`/vendor/${currentUser.id}/create-service`} className="action-button">
            <BsPlusCircleFill />
            <span>Create Services</span>
          </Link>
          <Link to={`/vendor/${currentUser.id}/chats`} className="action-button">
            <BsChatDotsFill />
            <span>Messages</span>
          </Link>
          <Link to={`/vendor/${currentUser.id}/analytics`} className="action-button">
            <BsBarChartLineFill />
            <span>Analytics</span>
          </Link>
        </div>

        {/* Business Photos Gallery */}
        {currentUser.business_photos?.length > 0 && (
          <div className="dashboard-section">
            <h4>Business Gallery</h4>
            <div className="photo-gallery">
              {currentUser.business_photos.map((photo, index) => (
                <div key={index} className="gallery-item">
                  <img src={photo} alt={`Business ${index}`} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <section className="my-5">
        {/* Site Footer */}
        <div>
          <SiteFooter />
        </div>
        {/* Download the app */}
        <div id='download-app-container' className='m-0'>
          <DownloadAppUI />
        </div>
      </section>
    </div>
  )
}

